import {
  CSSProperties,
} from 'react';

export interface WidgetProps {
  widgetParams: Record<string, string>;
  defaultPaddings: CSSProperties;
}

export enum ColorPalette {
  primary = "primary",
  onSurface = "onSurface",
  onSurfaceMedium = "onSurfaceMedium"
}